import { IDVerificationAction } from '../actions/IDVerificationAction'
import { SequenceManagerAction } from '../actions/SequenceManagerAction'

const initState = {
    requestBody: {
        sectionId: "idVerification",
        steps: [
            {
                sequence: "0",
                stepId: "idVerification",
                offerContainerId: "",
                fields: [
                    {
                        name: "IDNumber",
                        value: ""
                    },
                    {
                        name: "",
                        value: ""
                    },
                    {
                        name: "OrderId",
                        value: ""
                    },
                    {
                        name: "ContactPhoneNumber",
                        value: ""
                    }, 
                    {
                        name: "NationalityISOCode",
                        value: ""
                    }
                ],
                options: [
                    {
                        name: "IDName",
                        value: ""
                    }
                ]
            }
        ]
    },
    initiateOTPResponse: {

    },
    validateOTPResponse: {

    },
    initiateIDVerificationOTPResponse: {

    },
    validateIDVerificationOTPResponse: {

    },
   resendIDVerificationOTPResponse: {

    }
}

const IDVerificationReducer = (state: any = initState, action: any) => {    
    const { type } = action;
    const { payload } = action;
    var IDVerificationValue = { ...state.requestBody.steps };

    switch (type) {
        case IDVerificationAction.ID_VERIFICATION_CEM_OTP_INITIATE_SUCCESS:
            return { ...state, initiateIDVerificationOTPResponse: payload };

        case IDVerificationAction.ID_VERIFICATION_CEM_OTP_VALIDATE_SUCCESS:
            return { ...state, validateIDVerificationOTPResponse: payload };

        case IDVerificationAction.ID_VERIFICATION_CEM_OTP_RSEND_SUCCESS:
            return { ...state, resendIDVerificationOTPResponse: payload };

        case IDVerificationAction.OTP_INITIATE_SUCCESS:
            return { ...state, initiateOTPResponse: payload };

        case IDVerificationAction.OTP_VALIDATE_SUCCESS:
            return { ...state, validateOTPResponse: payload };

        case IDVerificationAction.UPDATE_ID_VERIFICATION:
            IDVerificationValue[0].fields[0].value = payload.idNumber;
            IDVerificationValue[0].fields[1].name = payload.nationalityFieldName;
            IDVerificationValue[0].fields[1].value = payload.nationality;
            IDVerificationValue[0].fields[2].value = payload.orderId;
            IDVerificationValue[0].fields[3].value = payload.contactPhone;
            IDVerificationValue[0].fields[4].value = payload.nationalityISOCode;
            IDVerificationValue[0].offerContainerId = payload.offerContainerId;
            IDVerificationValue[0].options[0].value = payload.idNumber.charAt(0) === '1' ? "Saudi National ID" : "IQAMA";
            return state;

        case SequenceManagerAction.DISPLAY_PREVIOUS_SECTION:
        case SequenceManagerAction.DISPLAY_SECTION:
            return { ...state, initiateOTPResponse: {}, validateOTPResponse:{}, initiateIDVerificationOTPResponse:{},validateIDVerificationOTPResponse:{}, resendIDVerificationOTPResponse:{} };

        case SequenceManagerAction.GET_CHECKOUT_SUCCESS:
            let section = payload.sections.filter((section: any) => {
                return (section.sectionId === 'idVerification')
            });
            if(section.length > 0) {
                IDVerificationValue[0].offerContainerId = section[0].steps[0].offerContainerId;
                IDVerificationValue[0].options[0].value = section[0].steps[0].options[0].value;
                IDVerificationValue[0].fields[1].name = section[0].steps[0].fields[1].name;
                IDVerificationValue[0].fields[1].value = section[0].steps[0].fields[1].value;
                for (let i = 0; i < IDVerificationValue[0].fields.length; i++) {
                    const checkoutField = section[0].steps[0].fields.filter((field: any) => { return (field.name === IDVerificationValue[0].fields[i].name) })[0];
                    IDVerificationValue[0].fields[i].value = checkoutField ? checkoutField.value : "";
                }
            }
            return state;
            
         default:
            return state;
    }
}

export default IDVerificationReducer;